import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppRouteConstants } from 'src/app/core/constants/AppRouteConstants';
import { AsstntsrchServiceService } from 'src/app/services/AsstntsrchService';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-post-conf-instr-asstnt',
  templateUrl: './post-conf-instr-asstnt.component.html',
  styleUrls: ['./post-conf-instr-asstnt.component.css']
})
export class PostConfInstrAsstntComponent implements OnInit {
name:string;
  constructor(private _router: Router,private _asstntSrchService: AsstntsrchServiceService,private _sharedService: SharedService) { }

  ngOnInit() {
    this._sharedService.publicNonEnrollFlow(false);
    this._sharedService.publicBreadCrumbFlagChange(true);
    this._sharedService.publicAnonFlowChanges(false);
    //this.name=localStorage.getItem('name');
    this.name = this._asstntSrchService.getAssisterNameInSession();
    this.name = this.name.replace("," , " ");
    //localStorage.removeItem('name');
  }

  submitHandler()
  {
    
    this._router.navigateByUrl("/"+AppRouteConstants.CNSMR_STTNG+"/"+AppRouteConstants.INDV_DSHBRD);
  }
 
  ngOnDestroy() {
    this._sharedService.publicNonEnrollFlow(true);
    this._sharedService.publicBreadCrumbFlagChange(false);
    this._sharedService.publicAnonFlowChanges(true);
 }
}
